import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/version";

/**
 * Classe de gerenciamento de chamadas da API do ProcedimentoPlanoOperadora
 *
 * @class
 */
export default class VersaoApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe AgendaApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
 * @returns registro da agenda
 */
  UltimaVersao() {
    return this.api<ApplicationModule[]>(`${controller}/lastversion`, {
      method: "GET",
    });
  }

}